import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from '../../../../../Typography/Typography';
export const Empty = ({ options, loading, value, }) => {
    const text = useMemo(() => `No results found for "${value}"`, [value]);
    const shouldShow = useMemo(() => !loading && options.length === 0 && value.length > 0, [loading, options, value]);
    if (!shouldShow)
        return null;
    return (_jsx("div", { "data-testid": 'auto-complete-component-no-options', children: _jsx(Typography.Text, { size: 'xs', children: text }) }));
};
